import { connect } from "react-redux";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import React, { useEffect } from "react";
import DatatableComponent from "../../helpers/DatatableComponent";
import FormDialog from "../../helpers/FormDialog";
import { IconButton } from "@mui/material";
import DeleteDialog from "../../helpers/DeleteDialog";
import { CheckHasPermission } from "helpers/Common_functions";

function MeetingTypeComponent({ type, SetSelectedMenu, location }) {
    const actionCode = "action.system.actions"
    const [open, setOpen] = React.useState(0);
    const [value, setValue] = React.useState({});
    const [list, setList] = React.useState([]);
    const [id, setId] = React.useState();
    const [deleteOpen, setDeleteOpen] = React.useState(false);
    const [count, setCount] = React.useState(0);

    useEffect(() => {
        SetSelectedMenu({
            menu: "seetings",
            title: "Meeting Type",
        });
    }, []);

    const columns = [
        {
            name: "code",
            label: "Code",
        },
        {
            name: "name",
            label: "Name",
        },

        {
            name: "id",
            label: "Action",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (v) => (
                    <div className="flex items-center">
                        {/* {CheckHasPermission(actionCode, "update") ? */}
                            <IconButton
                                onClick={() => {
                                    setOpen(2);
                                    const obj = list.find((vx) => vx.id === v);
                                    setId(v);
                                    setValue0("name", obj?.name);
                                    setValue0("code", obj?.code);
                                }}
                            >
                                <img
                                    src={require("../../assets/icons/pencil.svg").default}
                                    alt="Decorative SVG"
                                    className="mr-2 text-sm"
                                />
                            </IconButton>
                            {/* : null} */}
                        {/* {CheckHasPermission(actionCode,"delete")? */}
                        <IconButton
                            onClick={() => {
                                setDeleteOpen(true);
                                setId(v);
                            }}
                        >
                            <img
                                src={require("../../assets/icons/trash.svg").default}
                                alt="Decorative SVG"
                                className="mr-2 text-sm"
                            />
                        </IconButton>
                    </div>
                ),
            },
        },
    ];
    const setValue0 = (name, val) => {
        if (!name) {
            return null;
        }

        setValue((v) => {
            v[name] = val;
            return { ...v };
        });
    };
    const onSuccess = () => setCount((v) => v + 1);

    return (
        <div className="w-full mb-12 px-4">
            <DeleteDialog
                open={deleteOpen}
                setOpen={() => setDeleteOpen(false)}
                onSuccess={onSuccess}
                url={`/api/meeting/type/delete/${id}`}
            />

            <FormDialog
                maxWidth={"md"}
                col={6}
                open={open > 0}
                onSuccess={() => {
                    onSuccess();
                }}
                setOpen={setOpen}
                url={
                    open === 1
                        ? "/api/meeting/type/create"
                        : `/api/meeting/type/update/${id}`
                }
                title={open === 1 ? "Create Meeting Type" : "Edit Meeting Type"}
                fields={[
                    {
                        name: "code",
                        label: "Code",
                        value: value["code"] || "",
                        required: true,
                        col: 12,
                        setValue: (val) => setValue0("code", val),
                    },
                    {
                        name: "name",
                        label: "Name",
                        value: value["name"] || "",
                        required: true,
                        col: 12,
                        setValue: (val) => setValue0("name", val),
                    },

                ]}
            />
            <DatatableComponent
                order={location.state?.order}
                search={false}
                viewColumns={false}
                searchfield={true}
                onAddNew={() => setOpen(1)}
                actionCode={actionCode}
                processData={(data) => {
                    setList(data.data.data || data.data || []);
                    return data.data || data;
                }}
                // processData={(data) => {
                //     const list = Array.isArray(data) ? data : data.data || [];
                //     setList(list.data || list);
                //     return list;
                // }}
                elevation={1}
                columns={columns}
                url={`/api/meeting/type/list?type=${type}&count=${count}`}
                title={`Meeting Type`}
            />
        </div>
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(MeetingTypeComponent);
